import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  INavigationLink,
  IOutletFeaturesDto,
  IRestUserMappingDto,
} from 'src/app/core/models';
import { BearerToken } from 'src/app/core/models/bearer.token';
import { CommonConstants, RouteConstants } from 'src/app/shared/constant';
import {
  AuthService,
  OutletService,
  ToastService,
  TokenService,
  HeaderService,
} from 'src/app/core/services';
import { Header } from 'primeng/api';

@Component({
  selector: 'ic-left-nav',
  templateUrl: './left-nav.component.html',
  styleUrls: ['./left-nav.component.scss'],
})
export class LeftNavComponent implements OnInit {
  public currentUser: BearerToken;
  public managerRights: IRestUserMappingDto;
  public outletFeatures: IOutletFeaturesDto;
  public showMenu = false;
  public navigation: INavigationLink[];
  private allNavigation: INavigationLink[] = [
    {
      id: RouteConstants.Route.Dashboard,
      label: 'Dashboard',
      icon: 'fa fa-home',
      url: '/home/dashboard',
    },
    {
      id: RouteConstants.Route.Menu,
      label: 'Menu',
      icon: 'fas fa-pizza-slice',
      url: '/home/menu-item',
    },
    {
      id: RouteConstants.Route.Order,
      label: 'Orders',
      icon: 'fa fa-universal-access',
      url: '/home/order',
    },
    {
      id: RouteConstants.Route.Customer,
      label: 'Customers',
      icon: 'fa fa-users',
      url: '/home/customer-member',
    },
    {
      id: RouteConstants.Route.Notification,
      label: 'Notifications',
      icon: 'fa fa-envelope',
      url: '/home/notification-app',
    },
    // {
    //   id: RouteConstants.Route.Rewards,
    //   label: 'Rewards',
    //   icon: 'fa fa-certificate',
    //   url: '/home/reward',
    // },
    {
      id: RouteConstants.Route.Coupon,
      label: 'Coupons',
      icon: 'fa fa-book',
      url: '/home/coupon',
    },
    {
      id: RouteConstants.Route.Event,
      label: 'Events',
      icon: 'fa fa-calendar',
      url: '/home/event',
    },
    {
      id: RouteConstants.Route.Reservation,
      label: 'Reservations',
      icon: 'fa fa-bookmark',
      url: '/home/reservation',
    },
    {
      id: RouteConstants.Route.TableOrdering,
      label: 'Table Ordering',
      icon: 'fa fa-table',
      url: '/home/table',
    },
    {
      id: RouteConstants.Route.Kiosk,
      label: 'Kiosk',
      icon: 'fa fa-tablet',
      url: '/home/kiosk-list',
    },
    {
      id: RouteConstants.Route.Giftcard,
      label: 'Giftcard',
      icon: 'fa fa-gift',
      url: '/giftcard/product',
    },
    // {
    //   id: RouteConstants.Route.Catering,
    //   label: 'Catering',
    //   icon: 'fa fa-briefcase',
    //   url: '/catering/setting',
    // },
    {
      id: RouteConstants.Route.Reports,
      label: 'Reports',
      icon: 'fa fa-briefcase',
      url: '/report/order-report',
    },
    {
      id: RouteConstants.Route.Setting,
      label: 'Settings',
      icon: 'fa fa-cogs',
      url: '/setting/outlet-profile',
    },
  ];

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly toastService: ToastService,
    private readonly tokenService: TokenService,
    private readonly outletService: OutletService,
    private readonly headerService: HeaderService,
  ) {
    this.currentUser = this.tokenService.getToken();
  }

  ngOnInit(): void {
    this.authService.outletFeature.subscribe((features) => {
      this.outletFeatures = features;
    });

    this.headerService.visibility$.subscribe(
      (visibility) => (this.showMenu = visibility),
    );

    if (
      this.currentUser.roles ===
      CommonConstants.Role[CommonConstants.Role.Administrator]
    ) {
      this.allNavigation.push(
        {
          id: RouteConstants.Route.Restaurant,
          label: 'Restaurants',
          icon: 'fa fa-university',
          url: '/home/restaurant',
        },
        {
          id: RouteConstants.Route.Outlet,
          label: 'Outlets',
          icon: 'fa fa-cubes',
          url: '/home/outlet',
        },
        {
          id: RouteConstants.Route.User,
          label: 'Users',
          icon: 'fa fa-user',
          url: '/home/user-application',
        },
        {
          id: RouteConstants.Route.Diagnostic,
          label: 'Diagnostics',
          icon: 'fa fa-search-plus',
          url: '/home/diagnostic-paid',
        },
        {
          id: RouteConstants.Route.Search,
          label: 'Search',
          icon: 'fa fa-search',
          url: '/home/search',
        },
        {
          id: RouteConstants.Route.Feature,
          label: 'Features',
          icon: 'fa fa-tasks',
          url: '/setting/feature',
        },
        {
          id: RouteConstants.Route.Masters,
          label: 'Masters',
          icon: 'fa fa-universal-access',
          url: '/master/third-party',
        },
        // {
        //   id: RouteConstants.Route.Banner,
        //   label: 'Banners',
        //   icon: 'fa fa-crosshairs',
        //   url: '/home/banner',
        // }
      );
    } else if (
      this.currentUser.roles ===
      CommonConstants.Role[CommonConstants.Role.Manager]
    ) {
      this.allNavigation.push(
        {
          id: RouteConstants.Route.Restaurant,
          label: 'Restaurants',
          icon: 'fa fa-university',
          url: '/home/restaurant',
        },
        {
          id: RouteConstants.Route.Outlet,
          label: 'Outlets',
          icon: 'fa fa-cubes',
          url: '/home/outlet',
        },
        {
          id: RouteConstants.Route.Feature,
          label: 'Features',
          icon: 'fa fa-tasks',
          url: '/setting/feature',
        },
        {
          id: RouteConstants.Route.Diagnostic,
          label: 'Sales Report',
          icon: 'fa fa-search-plus',
          url: '/home/diagnostic-paid',
        },
      );
    } else if (
      this.currentUser.roles ===
      CommonConstants.Role[CommonConstants.Role.Restaurant]
    ) {
      this.allNavigation.push(
        {
          id: RouteConstants.Route.Outlet,
          label: 'Outlets',
          icon: 'fa fa-cubes',
          url: '/home/outlet',
        },
        // {
        //   id: RouteConstants.Route.Banner,
        //   label: 'Banners',
        //   icon: 'fa fa-crosshairs',
        //   url: '/home/banner',
        // }
      );
    }

    let manageNavItems = () => {
      if (!this.outletFeatures?.tableOrder) {
        this.navigation = this.navigation.filter(
          (x) => x.id !== RouteConstants.Route.TableOrdering,
        );
      }
      if (!this.outletFeatures?.kioskOrder) {
        this.navigation = this.navigation.filter(
          (x) => x.id !== RouteConstants.Route.Kiosk,
        );
      }
      if (!this.outletFeatures?.tableBooking) {
        this.navigation = this.navigation.filter(
          (x) => x.id !== RouteConstants.Route.Reservation,
        );
      }
      if (!this.outletFeatures?.event) {
        this.navigation = this.navigation.filter(
          (x) => x.id !== RouteConstants.Route.Event,
        );
      }
      if (!this.outletFeatures?.coupon) {
        this.navigation = this.navigation.filter(
          (x) => x.id !== RouteConstants.Route.Coupon,
        );
      }
      if (!this.outletFeatures?.giftCard) {
        this.navigation = this.navigation.filter(
          (x) => x.id !== RouteConstants.Route.Giftcard,
        );
      }
      if (!this.outletFeatures?.menuCatering) {
        this.navigation = this.navigation.filter(
          (x) => x.id !== RouteConstants.Route.Catering,
        );
      }
    };

    let outletFeatures = () => {
      this.outletService.getOutletFeatures(this.currentUser.outletId).subscribe(
        (data) => {
          this.authService.setOutletFeatures(data);
          this.outletFeatures = data;
          manageNavItems();
        },
        (err) => {
          this.toastService.showError(err);
        },
      );
    };

    this.authService.isOutletChange.subscribe((change) => {
      this.currentUser = this.tokenService.getToken();
      this.validateManagerAccess();
      if (this.currentUser.restaurantId === 0) {
        this.navigation = this.allNavigation.filter(
          (x) =>
            x.id === RouteConstants.Route.Restaurant ||
            x.id === RouteConstants.Route.User ||
            x.id === RouteConstants.Route.Masters ||
            x.id === RouteConstants.Route.Diagnostic ||
            x.id === RouteConstants.Route.Search,
        );
      } else if (this.currentUser.outletId === 0) {
        this.navigation = this.allNavigation.filter(
          (x) =>
            x.id === RouteConstants.Route.Restaurant ||
            x.id === RouteConstants.Route.User ||
            x.id === RouteConstants.Route.Masters ||
            x.id === RouteConstants.Route.Diagnostic ||
            x.id === RouteConstants.Route.Search ||
            x.id === RouteConstants.Route.Customer ||
            // x.id === RouteConstants.Route.Rewards ||
            x.id === RouteConstants.Route.Notification ||
            x.id === RouteConstants.Route.Banner ||
            x.id === RouteConstants.Route.Outlet,
        );
      } else {
        this.navigation = this.allNavigation;
        if (
          this.currentUser.outletId > 0 &&
          this.currentUser.roles !==
            CommonConstants.Role[CommonConstants.Role.Administrator]
        ) {
          if (this.outletFeatures) {
            manageNavItems();
          } else {
            outletFeatures();
          }
        }
      }
      this.navigation.sort((a, b) => (a.id > b.id ? 1 : -1));
    });

    this.authService.breadCrumb.subscribe((bc) => {
      this.navigation.forEach((x) => (x.isActive = false));
      const id = bc[0]?.id;
      const item = this.navigation.find((x) => x.id == id);
      if (item) {
        item.isActive = true;
      }
    });
  }

  changeNavItem(item: INavigationLink) {
    this.navigation.forEach((x) => (x.isActive = false));
    item.isActive = true;
  }

  validateManagerAccess() {
    if (
      this.currentUser.roles ===
      CommonConstants.Role[CommonConstants.Role.Manager]
    ) {
      const isFeature = this.authService.getModuleAccess(
        RouteConstants.ManagerAccess.AccessFeature,
      );
      if (
        isFeature &&
        this.allNavigation.findIndex(
          (x) => x.id === RouteConstants.Route.Feature,
        ) === -1
      ) {
        this.allNavigation.push({
          id: RouteConstants.Route.Feature,
          label: 'Features',
          icon: 'fa fa-tasks',
          url: '/setting/feature',
        });
      } else {
        const index = this.allNavigation.findIndex(
          (x) => x.id === RouteConstants.Route.Feature,
        );

        if (index > -1 && !isFeature) {
          this.allNavigation.splice(index, 1);
        }
      }

      const isPassword = this.authService.getModuleAccess(
        RouteConstants.ManagerAccess.AccessPassword,
      );
      if (
        isPassword &&
        this.currentUser?.restaurantId > 0 &&
        this.allNavigation.findIndex(
          (x) => x.id === RouteConstants.Route.User,
        ) === -1
      ) {
        this.allNavigation.push({
          id: RouteConstants.Route.User,
          label: 'Users',
          icon: 'fa fa-user',
          url: '/home/user',
        });
      }
      if (this.currentUser?.restaurantId === 0) {
        const index = this.allNavigation.findIndex(
          (x) => x.id === RouteConstants.Route.User,
        );
        if (index > -1) {
          this.allNavigation.splice(index, 1);
        }
      }
    }
  }
}
